
import * as react from "@sentry/react";
import { substring } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { replace } from "./fable_modules/fable-library-js.5.0.0-rc.2/RegExp.js";
import { int32ToString, Exception } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function environmentForHost(hostname) {
    let matchResult;
    switch (hostname) {
        case "localhost":
        case "127.0.0.1": {
            matchResult = 0;
            break;
        }
        default:
            if (hostname.startsWith("staging.")) {
                matchResult = 1;
            }
            else if (hostname.startsWith("review-")) {
                matchResult = 2;
            }
            else {
                matchResult = 3;
            }
    }
    switch (matchResult) {
        case 0:
            return "e2e";
        case 1:
            return "staging";
        case 2:
            return "review";
        default:
            return "production";
    }
}

function isReportingEnabled(environment) {
    return environment !== "e2e";
}

export function initializeSentry(userData) {
    const environment = environmentForHost(window.location.hostname);
    const initData = {
        dsn: "https://923a16423eb6d7c5f6515c835d0246e5@o4507814370541568.ingest.de.sentry.io/4507819750326352",
        enabled: isReportingEnabled(environment),
        environment: environment,
    };
    react.init(initData);
    if (userData == null) {
    }
    else {
        const userData_1 = userData;
        react.setUser({
            email: userData_1.UserName,
            id: userData_1.CustomerId,
        });
        react.setTag("customerId", userData_1.CustomerId);
    }
}

export function captureException(error) {
    react.captureException(error);
}

const guidPattern = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gu;

export function pathOf(url) {
    const matchValue = url.indexOf("?") | 0;
    if (matchValue === -1) {
        return url;
    }
    else {
        return substring(url, 0, matchValue);
    }
}

export function routeOf(url) {
    return replace(guidPattern, pathOf(url), "{id}");
}

export function reportHttpError(status, url, level) {
    const path = pathOf(url);
    const route = routeOf(path);
    react.captureException((new Exception(`HTTP ${status} ${route}`)), {
        extra: {
            url: path,
        },
        fingerprint: ["http", int32ToString(status), route],
        level: level,
        tags: {
            route: route,
            status: int32ToString(status),
        },
    });
}

